import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-connectivitysetup',
  imports: [],
  providers: [MessageService],
  templateUrl: './connectivitysetup.component.html',
  styleUrl: './connectivitysetup.component.css',
})
export class ConnectivitysetupComponent {
}
